import Modal from "@/components/Common/Modal";
import {isCommunityCodesCsvModalOpenAtom} from "@/store/jotaiAtoms";
import {useSetAtom} from "jotai";
import {Gift, Link as LinkIcon, MapPin, Ticket} from "lucide-react";
import {type FC, type ReactNode} from "react";
import {useTranslation} from "react-i18next";

const CommunityCodesCsvModal: FC = () => {
  const {t} = useTranslation("campaign_preparation");
  const setOpen = useSetAtom(isCommunityCodesCsvModalOpenAtom);

  const columns: {body: string; icon: ReactNode; title: string}[] = [
    {icon: <Ticket className="size-4" />, title: t("cc_csv_col_codes_title"), body: t("cc_csv_col_codes_body")},
    {icon: <Gift className="size-4" />, title: t("cc_csv_col_vouchers_title"), body: t("cc_csv_col_vouchers_body")},
    {icon: <MapPin className="size-4" />, title: t("cc_csv_col_addresses_title"), body: t("cc_csv_col_addresses_body")},
    {icon: <LinkIcon className="size-4" />, title: t("cc_csv_col_utm_title"), body: t("cc_csv_col_utm_body")},
  ];
  const goodToKnow: {body: string; title: string}[] = [
    {title: t("cc_csv_gtk_one_file_title"), body: t("cc_csv_gtk_one_file_body")},
    {title: t("cc_csv_gtk_reupload_title"), body: t("cc_csv_gtk_reupload_body")},
    {title: t("cc_csv_gtk_nothing_wiped_title"), body: t("cc_csv_gtk_nothing_wiped_body")},
  ];

  return (
    <Modal
      onClose={() => setOpen(false)}
      modalTitle={t("cc_csv_modal_title")}
      backgroundClassName="max-w-160"
      customBottomRow={<></>}>
      <p className="text-neutral-grey-dark text-sm leading-relaxed">{t("cc_csv_modal_intro")}</p>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        {columns.map(column => (
          <div key={column.title} className="border-neutral-white-dark rounded-xl border p-4">
            <div className="bg-primary-powder text-primary-dark-solid mb-3 flex size-9 items-center justify-center rounded-lg">
              {column.icon}
            </div>
            <div className="text-neutral-black text-sm font-bold">{column.title}</div>
            <p className="text-neutral-grey-dark mt-1 text-xs leading-relaxed">{column.body}</p>
          </div>
        ))}
      </div>
      <div>
        <div className="text-neutral-grey-dark text-2xs font-bold tracking-wide uppercase">
          {t("cc_csv_gtk_eyebrow")}
        </div>
        <div className="mt-2.5 grid grid-cols-1 gap-2.5 sm:grid-cols-3">
          {goodToKnow.map(item => (
            <div key={item.title} className="bg-primary-powder rounded-xl p-3">
              <div className="text-primary-dark-solid text-xs font-bold">{item.title}</div>
              <p className="text-neutral-grey-dark mt-1 text-xs leading-snug">{item.body}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="border-neutral-white-dark text-neutral-grey-light flex flex-col gap-1.5 border-t pt-3.5 text-xs">
        <span>{t("cc_csv_modal_footnote_tracking")}</span>
        <span>{t("cc_csv_modal_footnote_accepted")}</span>
      </div>
    </Modal>
  );
};

export default CommunityCodesCsvModal;
